import { Flex, Stack, useMantineTheme } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import type { JSX, ReactNode } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, CurrencyEntry, InlineEdit, UniversalSelect, Well } from '@feathr/components';
import { ConversionModelRadios } from '@feathr/extender/components';
import { useStore } from '@feathr/extender/state';
import { getIconForAction } from '@feathr/hooks';

import * as styles from './GoalLayout.css';

interface IProps {
  children: ReactNode;
}

function GoalLayout({ children }: Readonly<IProps>): JSX.Element {
  const { Goals } = useStore();
  const { t } = useTranslation();
  const {
    spacing: { '4': gap },
  } = useMantineTheme();
  const goal = Goals.create({ name: 'New test goal', conv_type: 'url_visit' });

  const options = [{ id: 'url_visit', name: t('URL Visit') }];

  return (
    <Well borderless={true}>
      <Stack gap={gap} w={'100%'}>
        <Flex align={'center'} direction={'row'} justify={'space-between'}>
          <InlineEdit attribute={'name'} className={styles.title} model={goal} />
          <Button type={'icon-small'}>{getIconForAction('close')}</Button>
        </Flex>
        <UniversalSelect
          label={t('Goal type')}
          options={options}
          value={options.find((option) => option.id === goal.get('conv_type'))}
        />
        {children}
        <CurrencyEntry
          description={t('Enter the monetary value of this goal. ')}
          label={t('Conversion value')}
        />
        <ConversionModelRadios goal={goal} />
      </Stack>
    </Well>
  );
}

export default observer(GoalLayout);
